export default {"src":"/_next/static/media/paw.4e348e4d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};